import { DefaultProductionIframeUrl, DefaultDevIframeUrl } from '../../Constants';

export function mapProdOrDogfoodEnvironmentToIframeUrl(iframeEnvironment: 'Prod' | 'Dogfood' | undefined) {
  switch (iframeEnvironment) {
    case undefined:
    case 'Prod':
      return DefaultProductionIframeUrl;
    case 'Dogfood':
      return DefaultDevIframeUrl;
    default:
      throw new Error(`Invalid environment "${iframeEnvironment}"`);
  }
}
